import { db } from '../firebase';
import {
  doc,
  getDoc,
  setDoc,
  collection,
  query,
  orderBy,
  limit,
  getDocs,
} from 'firebase/firestore';

export const generateMembershipId = async () => {
  const currentYear = new Date().getFullYear().toString().slice(-2); // Get last 2 digits of year
  const counterRef = doc(db, 'counters', 'membershipId');

  try {
    // Get the latest counter value for the current year
    const counterDoc = await getDoc(counterRef);
    const counterData = counterDoc.exists()
      ? counterDoc.data()
      : { year: currentYear, lastNumber: 0 };

    // If it's a new year, reset the counter
    if (counterData.year !== currentYear) {
      counterData.year = currentYear;
      counterData.lastNumber = 0;
    }

    // Increment the counter
    const newNumber = counterData.lastNumber + 1;

    // Ensure we don't exceed 9999 members per year
    if (newNumber > 9999) {
      throw new Error('Maximum member limit reached for this year');
    }

    // Update the counter in Firestore
    await setDoc(counterRef, {
      year: currentYear,
      lastNumber: newNumber,
    });

    // Format: OEC + YY + XXXX (padded number)
    const paddedNumber = String(newNumber).padStart(4, '0');
    return `OEC${currentYear}${paddedNumber}`;
  } catch (error) {
    console.error('Error generating membership ID:', error);
    throw error;
  }
};

export const assignMembershipIdToUser = async (userId) => {
  const userRef = doc(db, 'users', userId);

  try {
    const userDoc = await getDoc(userRef);
    if (!userDoc.exists()) {
      throw new Error('User not found');
    }

    const userData = userDoc.data();

    // Only generate new membership ID if user doesn't have one
    if (!userData.membershipId) {
      const membershipId = await generateMembershipId();
      await setDoc(
        userRef,
        {
          ...userData,
          membershipId,
          membershipDate: new Date(),
        },
        { merge: true },
      );

      return membershipId;
    }

    return userData.membershipId;
  } catch (error) {
    console.error('Error assigning membership ID:', error);
    throw error;
  }
};

export const validateMembershipId = (membershipId) => {
  // Pattern: OEC + 2 digits for year + 4 digits for member number
  const pattern = /^OEC\d{2}\d{4}$/;
  return pattern.test(membershipId);
};
